'use client';
import { usePathname } from 'next/navigation';
import Link from 'next/link';
import SvgIllustration from '../Illustration/SvgIllustration';
import { BlankLogo } from '../SVGs';
import { useTheme } from '../../context/ThemeContext';
import DarksideToggle from '../Darkside/DarksideToggle';

interface HeaderProps {
  children?: React.ReactNode | React.ReactNode[];
  isFixed?: boolean;
}

const Header = ({ children, isFixed = true }: HeaderProps) => {
  return (
    <div className={`w-full relative ${isFixed && 'fixed z-20 top-0'}`}>
      <nav
        className={`flex items-center justify-between mx-auto w-full h-header px-16 laptop:px-24 overflow-x-clip`}
      >
        <BlankLogoLink />
        {children}
      </nav>
    </div>
  );
};

const HeaderWithDarksideToggle = ({
  children,
  isFixed = true,
}: HeaderProps) => {
  // The positioning of the dark side toggle is a bit hacky, sorry:-)
  // Difficult because of the animation

  const { theme } = useTheme();
  const pathname = usePathname();
  const isFrontPage = pathname === '/';
  const isDarkside = theme === 'darkside';
  const isProsjektprat = pathname === '/prosjektprat';

  if (isProsjektprat) {
    return null;
  }

  return (
    <div
      className={`w-full ${isFixed && 'fixed z-20 top-0 pointer-events-none'}`}
    >
      <nav
        className={`flex items-center justify-between mx-auto w-full h-header px-16 laptop:px-24 overflow-x-clip ${
          !isFrontPage && 'max-xl-content'
        }`}
      >
        {!isDarkside && (
          <>
            <BlankLogoLink />
            {children}
          </>
        )}
        <div className="absolute top-20 right-24">
          <DarksideToggle />
        </div>
      </nav>
    </div>
  );
};

const BlankLogoLink = () => {
  return (
    <Link
      href="/"
      className="hover:bg-transparent no-line-hover-line hover:text-current pointer-events-auto"
      aria-label="Hjem til Blank.no"
    >
      <SvgIllustration>
        <BlankLogo className="w-[93px] h-[31px] tablet:w-[105px] tablet:h-[34px]" />
      </SvgIllustration>
    </Link>
  );
};

export { Header, HeaderWithDarksideToggle };
